/*
  SMANT: rekenkern van het bestelblok op vloerpagina's (zie snippets/smant-bestelblok.liquid).
  Alleen pure functies, geen DOM, zodat theme/tests/bestel-core.test.mjs ze met node --test
  kan testen. In de browser beschikbaar als window.SmantBestel.
*/
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SmantBestel = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var MIN_M2 = 10;
  /* Marge tegen drijvende-kommafouten: 22,2 / 2,22 is in JS 10,000000000000002. */
  var EPS = 1e-9;

  function round3(n) {
    return Math.round(n * 1000) / 1000;
  }

  /** "24", "24,5", "24.5" en "24," (tijdens typen) worden getallen; al het andere NaN. */
  function parseNum(v) {
    var s = String(v == null ? '' : v).replace(/\s/g, '').replace(',', '.');
    if (!/^(\d+(\.\d*)?|\.\d+)$/.test(s)) return NaN;
    return parseFloat(s);
  }

  /**
   * Getallen uit metafields, die vaak een eenheid hebben ("1,85 m²", "3,66 M2", "2.074 M2").
   * Leest het getal vooraan; 0 als er geen is.
   */
  function parseMeasure(v) {
    var m = String(v == null ? '' : v).replace(',', '.').match(/^\s*(\d+(\.\d+)?|\.\d+)/);
    return m ? parseFloat(m[1]) : 0;
  }

  function fmtNum(n) {
    return String(round3(n)).replace('.', ',');
  }

  function euro(cents) {
    var s = ((cents || 0) / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + s[0] + ',' + s[1];
  }

  /**
   * Pakmodus (packM2 > 0): pakken = ceil(m² × (1 + snijverlies) / pakmaat), qty = pakken,
   * unitCents = prijs per pak. m²-modus: qty = ceil(m²), unitCents = prijs per m².
   */
  function calcFloor(o) {
    var m2 = parseNum(o.m2);
    var r = {
      entered: !isNaN(m2) && m2 > 0,
      valid: false,
      mode: o.packM2 > 0 ? 'pack' : 'm2',
      m2: isNaN(m2) ? 0 : m2,
      areaIncl: 0,
      packs: 0,
      totalArea: 0,
      qty: 0,
      totalCents: 0,
    };
    if (!r.entered) return r;
    r.valid = m2 >= MIN_M2;
    if (r.mode === 'pack') {
      r.areaIncl = round3(m2 * (1 + (o.useWaste ? o.wastePct : 0) / 100));
      r.packs = Math.ceil(r.areaIncl / o.packM2 - EPS);
      r.totalArea = round3(r.packs * o.packM2);
      r.qty = r.packs;
    } else {
      r.areaIncl = m2;
      r.qty = Math.ceil(m2 - EPS);
      r.totalArea = r.qty;
    }
    r.totalCents = r.qty * o.unitCents;
    return r;
  }

  function emptyAnswers() {
    return {
      legservice: null,
      plinten: { choice: null, variantId: null, meters: '' },
      inloopmat: { choice: null, w: '', l: '' },
    };
  }

  /** Stapvolgorde. De mat wordt alleen op maat gesneden in combinatie met leg service. */
  function steps(cfg, a) {
    var out = [];
    var lsAvailable = !!cfg.legservice && !cfg.isBundle;
    if (lsAvailable) out.push('legservice');
    out.push('plinten');
    if (cfg.mat && (cfg.isBundle || (lsAvailable && a.legservice === 'ja'))) out.push('inloopmat');
    out.push('overzicht');
    return out;
  }

  function between(v, min, max) {
    var n = parseNum(v);
    return !isNaN(n) && n >= min && n <= max;
  }

  function findPlint(cfg, id) {
    for (var i = 0; i < cfg.plinten.length; i++) if (cfg.plinten[i].variantId === Number(id)) return cfg.plinten[i];
    return null;
  }

  function validateStep(key, cfg, a) {
    if (key === 'legservice') return a.legservice ? '' : 'Kies een antwoord.';
    if (key === 'plinten') {
      var p = a.plinten;
      if (!p.choice) return 'Kies een antwoord.';
      if (p.choice === 'nee') return '';
      if (p.choice === 'type' && !findPlint(cfg, p.variantId)) return 'Kies een type plint.';
      return between(p.meters, 1, 500) ? '' : 'Vul een wandlengte tussen 1 en 500 meter in.';
    }
    if (key === 'inloopmat') {
      var m = a.inloopmat;
      if (!m.choice) return 'Kies een antwoord.';
      if (m.choice === 'nee') return '';
      return between(m.w, 20, 500) && between(m.l, 20, 500) ? '' : 'Vul breedte en lengte tussen 20 en 500 cm in.';
    }
    return '';
  }

  function floorDetail(calc) {
    if (calc.mode === 'pack') return calc.packs + (calc.packs === 1 ? ' pak' : ' pakken') + ', ' + fmtNum(calc.totalArea) + ' m²';
    return calc.qty + ' m²';
  }

  /**
   * Winkelwagenregels + overzichtsregels. Wordt pas bij "Toevoegen" aangeroepen met een verse
   * calc, zodat een gewijzigde m² altijd meetelt. Antwoorden van stappen die niet (meer) in
   * steps() staan, tellen niet mee.
   */
  function buildOrder(cfg, calc, a) {
    var list = steps(cfg, a);
    /* _m2 en _pakken: de winkelwagen toont m² i.p.v. pakken (snippets/smant-cart-m2.liquid). */
    var floorProps = { _m2: fmtNum(calc.mode === 'pack' ? calc.m2 : calc.qty) };
    if (calc.mode === 'pack') floorProps._pakken = floorDetail(calc);
    var items = [{ id: cfg.floorVariantId, quantity: calc.qty, properties: floorProps }];
    var lines = [{ label: cfg.floorTitle, detail: floorDetail(calc), cents: calc.totalCents }];
    var total = calc.totalCents;
    var lsYes = false;

    if (cfg.isBundle) {
      lsYes = true;
      floorProps['Leg service'] = 'Inbegrepen';
      lines.push({ label: 'Leg service', detail: 'Inbegrepen', cents: 0 });
    } else if (list.indexOf('legservice') > -1) {
      if (a.legservice === 'ja') {
        lsYes = true;
        var m2c = Math.ceil(calc.m2 - EPS);
        var lsCents = m2c * cfg.legservice.priceCents;
        items.push({
          id: cfg.legservice.variantId,
          quantity: m2c,
          properties: { 'Voor vloer': cfg.floorTitle, 'm²': m2c + ' (definitieve m² na inmeten)', _m2: String(m2c) },
        });
        lines.push({ label: 'Leg service', detail: m2c + ' m² × ' + euro(cfg.legservice.priceCents), cents: lsCents });
        total += lsCents;
      } else if (a.legservice === 'advies') {
        floorProps['Leg service'] = 'Advies gewenst';
        lines.push({ label: 'Leg service', detail: 'Advies gewenst, wij nemen contact op', cents: null });
      }
    }

    var p = a.plinten;
    var meters = parseNum(p.meters);
    if (p.choice === 'type') {
      var opt = findPlint(cfg, p.variantId);
      var boards = Math.ceil(meters / cfg.plintBoardM - EPS);
      var pCents = boards * opt.priceCents;
      var pProps = { 'Strekkende meter': fmtNum(meters) + ' m' };
      if (lsYes) pProps.Plaatsen = 'Inbegrepen bij leg service';
      items.push({ id: opt.variantId, quantity: boards, properties: pProps });
      lines.push({ label: 'Plinten', detail: opt.name + ', ' + boards + (boards === 1 ? ' plank' : ' planken'), cents: pCents });
      total += pCents;
    } else if (p.choice === 'advies') {
      floorProps.Plinten = 'Bijpassende plint laten kiezen, ca. ' + fmtNum(meters) + ' m';
      lines.push({ label: 'Plinten', detail: 'Wij kiezen een bijpassende plint (ca. ' + fmtNum(meters) + ' m) en nemen contact op', cents: null });
    }

    var m = a.inloopmat;
    if (list.indexOf('inloopmat') > -1 && m.choice === 'ja') {
      var size = fmtNum(parseNum(m.w)) + ' × ' + fmtNum(parseNum(m.l)) + ' cm';
      floorProps['Inloopmat op maat'] = size + ', prijs volgt';
      lines.push({ label: 'Inloopmat op maat', detail: size + ', prijs volgt na inmeten', cents: null });
    }

    return { items: items, lines: lines, totalCents: total };
  }

  return {
    MIN_M2: MIN_M2,
    EPS: EPS,
    parseNum: parseNum,
    parseMeasure: parseMeasure,
    fmtNum: fmtNum,
    euro: euro,
    calcFloor: calcFloor,
    emptyAnswers: emptyAnswers,
    steps: steps,
    validateStep: validateStep,
    buildOrder: buildOrder,
  };
});
